<template>
  <div class="rtsp-Plug">
    <div class="rtsp-Plug_Description">
      <AppIcon
        v-if="isPlatformElementInAutoGrade && iconName"
        :icon-name="iconName"
        height="32"
        width="32"
      />

      <div class="rtsp_Description_Content">
        {{ description }}
      </div>
    </div>
    <div
      :class="{
        'rtsp-Plug_Hero-binary': isBinary && !isPlatformElementInAutoGrade,
        'rtsp-Plug_Hero-auto-grade': isPlatformElementInAutoGrade && !isAzureApp,
        'rtsp-Plug_Hero-azure-auto-grade': isPlatformElementInAutoGrade && isAzureApp
      }"
      class="rtsp-Plug_Hero"
    />
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'

import { isAzureAppInjectionKey } from '@/utils/injection-keys'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'ResultTypeSettingsPlug'
})

const props = defineProps({
  isBinary: {
    type: Boolean
  },

  isPlatformElementInAutoGrade: {
    type: Boolean
  }
})

const { t } = useI18n()

const description = computed(() => {
  if (props.isPlatformElementInAutoGrade) {
    if (isAzureApp) return t('azure.auto_grade.description')

    return t('jira.auto_grade.description')
  }

  return t('element.binary_plug.message')
})

const isAzureApp = inject(isAzureAppInjectionKey)

const iconName = computed(() => {
  if (isAzureApp) {
    return 'azure-icon-full-width'
  }

  return 'jira-icon-full-width'
})
</script>

<style lang="scss" scoped>
.rtsp-Plug {
  display: flex;
  min-height: 172px;
  align-items: center;
}

.rtsp-Plug_Description {
  padding: var(--padding-block);
  font-weight: fw('semi-bold');
  font-size: $fs-14;
  line-height: 20px;
  color: $dark-1;
  gap: 30px;
  display: grid;
}

.rtsp-Plug_Hero {
  height: 100%;
  width: min(278px, 50%);
  flex-shrink: 0;
  border-radius: $border-radius-md-next;
  border: 2px solid $grey-3-next;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: $white;

  &-binary {
    background-image: url('~@/assets/images/binary-settings-plug.svg');
  }

  &-auto-grade {
    background-image: url('~@/assets/images/jira-in-progress-large.svg');
  }

  &-azure-auto-grade {
    background-image: url('~@/assets/images/azure-in-progress-large.svg');
  }
}
</style>
